module.exports = __webpack_public_path__ + "assets/img/store-phone-3.e4fe0b7a.png";